module.exports = "/fast-coin/img/coin/anim/out_1/out_1_005.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/out_1/out_1_005.png
// module id = 2301
// module chunks = 5